<template>
  <div
    :id="id"
    v-loading="loading"
    class="vegaContain"
    element-loading-text="数据统计中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  ></div>
</template>

<script>
import * as vega from "vega";
import apiAxios from "@/config/apiAxios";
export default {
  name: "annt",
  props: {
    id: {
      type: String,
      required: true,
      default: "",
    },
    width: {
      type: String,
      default: document.body.clientWidth / 3 - 20 + "px",
    },
    height: {
      type: String,
      default: "320px",
    },
  },
  components: {},
  data() {
    return {
      vegaDefaultConfig: {
        $schema: "https://vega.github.io/schema/vega/v5.json",
        description:
          "A heatmap showing average daily temperatures in Seattle for each hour of the day.",
        width: 500,
        height: 300,
        padding: 0,
        autosize: "fit",

        title: {
         // text: "2022年年报披露热力（日披露家数）",
         text: "2023年半年报披露热力（日披露家数）",
          color: "#fff",
          subtitleColor: "#fff",
          anchor: "middle",
          fontSize: 16,
          frame: "group",
          offset: 4,
        },

        signals: [
          {
            name: "month",
          //  value: [1, 2, 3, 4],
          value: [ 7, 8],
          },
          {
            name: "palette",
            value: "turbo",
          },
          {
            name: "width",
            update: "containerSize()[0]",
            on: [
              {
                events: { source: "window", type: "resize" },
                update: "containerSize()[0]",
              },
            ],
          },
          {
            name: "height",
            update: "containerSize()[1]",
            on: [
              {
                events: { source: "window", type: "resize" },
                update: "containerSize()[1]",
              },
            ],
          },
        ],

        data: [
          {
            name: "infodisc",
            values: [],
            transform: [
              {
                type: "formula",
                expr: "if(datum.F003D,datum.F003D,datum.F002D)",
                as: "F002D",
              },
              {
                type: "formula",
                expr: "if(datum.F004D,datum.F004D,datum.F002D)",
                as: "F002D",
              },
              {
                type: "formula",
                expr: "if(datum.F005D,datum.F005D,datum.F002D)",
                as: "F002D",
              },
              {
                type: "formula",
                expr: "if(datum.F007D,datum.F007D,datum.F002D)",
                as: "F002D",
              },
              {
                type: "formula",
                expr: "if(datum.F008D,datum.F008D,datum.F002D)",
                as: "F002D",
              },
              {
                type: "formula",
                expr: "month(datum.F002D)+1+'-'+date(datum.F002D)",
                as: "date",
              },
              {
                type: "aggregate",
                fields: ["SECCODE"],
                groupby: ["date"],
                ops: ["count"],
                as: ["count"],
              },
              {
                type: "collect",
                sort: { field: ["month", "day"] },
              },
            ],
          },
          {
            name: "fullmonthday",
            transform: [
              {
                type: "sequence",
                start: 1,
                stop: 32,
                as: "day",
              },
              {
                type: "formula",
                expr: "month",
                as: "month",
              },
              {
                type: "flatten",
                fields: ["month"],
                as: ["month"],
              },
              {
                type: "collect",
                sort: {
                  field: ["month", "day"],
                },
              },
              {
                type: "formula",
                expr: "datum.month+'-'+datum.day",
                as: "date",
              },
              {
                type: "lookup",
                from: "infodisc",
                key: "date",
                fields: ["date"],
                values: ["count"],
              },
              {
                type: "formula",
                expr: "if(datum.count,datum.count,0)",
                as: "count",
              },
            ],
          },
        ],

        scales: [
          {
            name: "x",
            type: "band",
            domain: [
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20,
              21,
              22,
              23,
              24,
              25,
              26,
              27,
              28,
              29,
              30,
              31,
            ],
            range: "width",
          },
          {
            name: "y",
            type: "band",
           // domain:[4,3,2,1],
            domain: [8, 7],
            range: "height",
          },
          {
            name: "color",
            type: "linear",
            range: { scheme: { signal: "palette" } },
            domain: { data: "fullmonthday", field: "count" },
            zero: false,
            nice: true,
          },
        ],

        axes: [
          {
            orient: "bottom",
            scale: "x",
            title: "日期",
            titleColor: "#fff",
            labelColor: "#fff",
          },
          {
            orient: "left",
            scale: "y",
            title: "月份",
            titleColor: "#fff",
            labelColor: "#fff",
            encode: {
              labels: {
                update: {
                  text: { signal: "datum.value+'月'" },
                },
              },
            },
          },
        ],
        legends: [
          {
            fill: "color",
            type: "gradient",
            title: "披露家数",
            titleColor: "#fff",
            labelColor: "#fff",
            titleFontSize: 12,
            titlePadding: 4,
            gradientLength: { signal: "height - 16" },
          },
        ],

        marks: [
          {
            type: "rect",
            from: { data: "fullmonthday" },
            encode: {
              enter: {
                x: { scale: "x", field: "day" },
                y: { scale: "y", field: "month" },
                width: { scale: "x", band: 1 },
                height: { scale: "y", band: 1 },
                tooltip: { signal: "datum.day+'日披露'+datum.count+'家'" },
              },
              update: {
                fill: { scale: "color", field: "count" },
              },
            },
          },
        ],
      },
      vegaView: {},
      loading: true,
    };
  },
  methods: {
    vegaInit(data) {
      let width = document.getElementById(this.id).clientWidth - 150;
      //let width = document.body.clientWidth/3 - 100;
      let height = document.getElementById(this.id).clientHeight - 30;
      // let width = document.body.clientWidth/3 -100;
      this.vegaDefaultConfig.width = width;
      this.vegaDefaultConfig.height = height;
      this.vegaDefaultConfig.data[0].values = data;

      let aa = vega.parse(this.vegaDefaultConfig);
      var view2 = new vega.View(vega.parse(this.vegaDefaultConfig))
        .renderer("svg")
        .initialize("#" + this.id)
        .hover()
        .run();
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.vegaContain {
  padding: 5px;
  // border: solid 1px;
  margin: 10px;
}
</style>
